module.exports = __webpack_public_path__ + "static/media/gdpr.33a064e6.svg";